import { ACTIONS } from '../constants';
import createRequest from '../utils/requestService';

export const setConfirmationEmail = email => ({ type: ACTIONS.SET_CONFIRMATION_EMAIL, email });

export const onSend = email => (dispatch) => {
  const url = '/v3/signup/send_confirmation';
  const body = {
    email,
  };
  return fetch(createRequest(url, { body })).then((response) => {
    switch (response.status) {
      case 200:
        return {
          emailSent: true,
        };
      case 204:
        return {
          emailSent: true,
        };
      default:
        return {
          emailSent: false,
        };
    }
  })
    .then((response) => {
      dispatch({
        type: ACTIONS.ON_SEND,
        emailSent: response.emailSent,
      });
      return response;
    }).catch((error) => {
      dispatch({
        type: ACTIONS.ON_SEND,
        emailSent: false,
      });
      return error;
    });
};




// WEBPACK FOOTER //
// ./src/actions/emailConfirmationInputs.js